import { useFetch } from 'vfetcher';
// OLD: imports were only used by the per-request toast/redirect handling below
// import store from '@/store';
// import router from "@/router";
// import { useErrorHandler, ErroneousResponseError } from "./error";

// NEW: 401/403 now show ONE blocking SessionExpiredModal with a "Log In" button
// (instead of a toast per failed request) — see services/error/sessionExpired.js.
// triggerSessionExpired dedupes, so parallel failing calls produce a single popup.
import { triggerSessionExpired } from "./error/sessionExpired.js";

// OLD: toast helper — replaced by the SessionExpiredModal popup
// const handleResponseError = (internal, friendly) => {
//   useErrorHandler(new ErroneousResponseError(internal, friendly), {
//     notify: true,
//     fallback: 'Sorry, access to this resource forbidden.',
//   });
// }

export function useAPI(url, options = {}) {
  const platformHeader = {
    "Dougjones": "web",
  };

  return useFetch(url, {
    ...options,
    baseURL: '/api',
    headers: {
      ...options.headers,
      ...platformHeader,
    },
    async onResponseError({ request, options, response }) {
      // OLD: showed a toast per failed request, and 401 logged out immediately —
      // when the session died, every in-flight call fired its own error toast.
      // if (typeof response._data === 'object') {
      //   const internal = response._data.message;
      //   if (response.status === 403) {
      //     const friendly = 'This account no longer exists. Contact support for help, or log out to return to the home screen.';
      //     handleResponseError(internal, friendly);
      //   }
      //   if (response.status === 401) {
      //     const friendly = 'Session expired. Please log in to continue.';
      //     store.dispatch('logOut');
      //     //router.go(); Test later which are better to use
      //     router.push('/');
      //     handleResponseError(internal, friendly);
      //   }
      // }

      // NEW: session closed / timed out (401/403) — show the blocking
      // SessionExpiredModal exactly once; its "Log In" button dispatches
      // logOut and redirects to /sign-in. Repeat failures are silent.
      if (response.status === 401 || response.status === 403) {
        // Backend code 403021 = account deleted — show a more specific message
        const accountGone = response.status === 403 && response._data?.code === 403021;
        triggerSessionExpired(
          accountGone
            ? 'This account no longer exists. Contact support for help, or log in with a different account.'
            : undefined,
        );
      }
    }
  })
}
